import React from 'react'

const MerchantConfigContext = React.createContext();

export const MerchantConfigProvider = MerchantConfigContext.Provider;
export const MerchantConfigConsumer = MerchantConfigContext.Consumer;
export default MerchantConfigContext;